// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.crafting-session-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 5vh;
  background: linear-gradient(to top, rgba(2, 3, 8, 0.65), rgba(2, 3, 8, 0) 55%);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.crafting-session-shell {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  width: min(820px, 94vw);
  padding: 18px 24px 18px;
  transition: border-color 0.2s ease;
}
.crafting-session-shell * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .crafting-session-shell {
    animation: none;
  }
}
.crafting-session-shell--ok {
  border-color: #8fbf8a;
}
.crafting-session-shell--fail {
  border-color: #d9786d;
}

.crafting-session-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.crafting-session-header__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.crafting-session-header__subtitle {
  margin-top: 4px;
  font-size: 14px;
  color: #aeaba2;
}
.crafting-session-header__recipe {
  flex-shrink: 0;
  padding: 4px 11px;
  font-size: 14px;
  font-weight: 600;
  color: var(--gold-light);
  border: 1px solid var(--gold-dark);
  border-radius: 6px;
}

.crafting-session-body {
  display: flex;
  gap: 24px;
  align-items: stretch;
  min-height: 200px;
}

.crafting-session-materials {
  flex: 0 0 190px;
  padding-right: 20px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}
.crafting-session-materials__heading {
  font-size: 13px;
  font-weight: 600;
  color: #8d8a82;
  margin-bottom: 4px;
}

.crafting-session-material {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 0;
  font-size: 14px;
  color: #ebe8e1;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.crafting-session-material__count {
  font-weight: 600;
  color: var(--gold-light);
  white-space: nowrap;
}

.crafting-session-stage {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.crafting-session-steps {
  display: flex;
  gap: 6px;
  margin: 0 0 18px;
  padding: 0;
  list-style: none;
}
.crafting-session-steps__item {
  flex: 1;
  padding: 6px 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #8d8a82;
  border-bottom: 3px solid rgba(255, 255, 255, 0.12);
  transition: color 0.15s ease, border-color 0.15s ease;
}
.crafting-session-steps__item--done {
  color: #aeaba2;
  border-bottom-color: var(--gold-dark);
}
.crafting-session-steps__item--current {
  color: var(--gold-light);
  border-bottom-color: var(--gold-main);
}

.crafting-session-gauge-heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 12px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 19px;
  color: #ebe8e1;
}
.crafting-session-gauge-heading__value {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: var(--gold-light);
  font-variant-numeric: tabular-nums;
}

.crafting-session-gauge-labels {
  display: flex;
  justify-content: space-between;
  margin: 8px 2px 6px;
  font-size: 13px;
  color: #8d8a82;
}
.crafting-session-gauge-labels__mid {
  color: #8fbf8a;
  font-weight: 600;
}

.crafting-session-gauge,
.crafting-session-timing,
.crafting-session-rhythm {
  position: relative;
  height: 44px;
  margin: 0 2px 20px;
  background: repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.07) 0, rgba(255, 255, 255, 0.07) 1px, transparent 1px, transparent 10%), rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  overflow: visible;
}

.crafting-session-gauge__zone,
.crafting-session-timing__zone {
  position: absolute;
  top: 0;
  bottom: 0;
  background: rgba(143, 191, 138, 0.26);
  border-left: 2px solid #8fbf8a;
  border-right: 2px solid #8fbf8a;
}

.crafting-session-gauge__needle,
.crafting-session-timing__marker,
.crafting-session-rhythm__marker {
  position: absolute;
  top: -8px;
  bottom: -8px;
  width: 3px;
  margin-left: -1.5px;
  background: var(--gold-light);
  border-radius: 2px;
  transition: left 0.1s linear;
}
.crafting-session-gauge__needle::before,
.crafting-session-timing__marker::before,
.crafting-session-rhythm__marker::before {
  content: "";
  position: absolute;
  top: -2px;
  left: 50%;
  width: 0;
  height: 0;
  margin-left: -6px;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid var(--gold-light);
}
@media (prefers-reduced-motion: reduce) {
  .crafting-session-gauge__needle,
  .crafting-session-timing__marker,
  .crafting-session-rhythm__marker {
    transition: none;
  }
}

.crafting-session-rhythm__point {
  position: absolute;
  top: 50%;
  width: 34px;
  height: 34px;
  margin-left: -17px;
  margin-top: -17px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 2px solid #8d8a82;
  transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .crafting-session-rhythm__point {
    transition: none;
  }
}
.crafting-session-rhythm__point--next {
  transform: scale(1.15);
  border-color: var(--gold-main);
}
.crafting-session-rhythm__point--perfect {
  border-color: var(--gold-light);
  background: rgba(255, 255, 255, 0.1);
  color: var(--gold-light);
}
.crafting-session-rhythm__point--good {
  border-color: #8fbf8a;
  background: rgba(143, 191, 138, 0.2);
  color: #8fbf8a;
}
.crafting-session-rhythm__point--late {
  border-color: #d4a455;
  background: rgba(212, 164, 85, 0.2);
  color: #d4a455;
}
.crafting-session-rhythm__point--miss {
  border-color: #d9786d;
  background: rgba(217, 120, 109, 0.2);
  color: #d9786d;
}

.crafting-session-rhythm__grade {
  position: absolute;
  top: 100%;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.crafting-session-quench-grade {
  margin-bottom: 8px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 22px;
  color: var(--gold-light);
}

.crafting-session-hint {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 14px;
  color: #aeaba2;
}
.crafting-session-hint__sep {
  margin-left: auto;
  color: #8d8a82;
}
.crafting-session-hint kbd {
  display: inline-block;
  padding: 3px 9px;
  margin: 0 4px 0 0;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom-width: 2px;
  border-radius: 4px;
}

.crafting-session-outcome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
}
.crafting-session-outcome__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 28px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.crafting-session-outcome__title--ok {
  color: #8fbf8a;
}
.crafting-session-outcome__title--fail {
  color: #d9786d;
}
.crafting-session-outcome__score {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.crafting-session-outcome__number {
  font-size: 56px;
  font-weight: 600;
  line-height: 1;
  color: #ebe8e1;
  font-variant-numeric: tabular-nums;
}
.crafting-session-outcome__unit {
  font-size: 16px;
  color: #aeaba2;
}

.crafting-session-footer {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 28px;
}

.crafting-session-bar {
  display: flex;
  align-items: center;
  gap: 10px;
}
.crafting-session-bar__label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  white-space: nowrap;
}
.crafting-session-bar__track {
  flex: 1;
  height: 8px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  overflow: hidden;
}
.crafting-session-bar__fill {
  height: 100%;
  transition: width 0.2s ease;
}
@media (prefers-reduced-motion: reduce) {
  .crafting-session-bar__fill {
    transition: none;
  }
}
.crafting-session-bar__fill--progress {
  background: var(--gold-main);
}
.crafting-session-bar__fill--quality {
  background: linear-gradient(90deg, #d9786d, #d4a455, #8fbf8a);
}
.crafting-session-bar__value {
  min-width: 3em;
  font-size: 13px;
  font-weight: 600;
  text-align: right;
  color: var(--gold-light);
  font-variant-numeric: tabular-nums;
}

@media (max-width: 640px) {
  .crafting-session-body {
    flex-direction: column;
  }
  .crafting-session-materials {
    flex: none;
    padding: 0 0 12px;
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
  .crafting-session-footer {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/craftingSession/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AADA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,8EAAA;EACA,oBAAA;EACA,yDDWU;ACTZ;;AACA;EDWE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECrJA,oBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kCAAA;AAQF;ADDE;EAAI,sBAAA;ACIN;ADyIE;EC1JF;ID0J4C,eAAA;ECrI1C;AACF;AAdE;EAAQ,qBDLA;ACsBV;AAhBE;EAAU,qBDPH;AC0BT;;AAhBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,kDAAA;AAmBF;AAjBE;EDaA,kDA3BW;EA4BX,gBAAA;EACA,eCf8B;EDgB9B,iBAAA;EACA,sBAAA;EACA,cAxCK;AC+CP;AAxBE;EAAc,eAAA;EAAiB,eAAA;EAAiB,cDtBzC;ACmDT;AA5BE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,kCAAA;EACA,kBD1BK;ACwDT;;AA1BA;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,iBAAA;AA6BF;;AA1BA;EACE,eAAA;EACA,mBAAA;EACA,iDAAA;AA6BF;AA3BE;EAAa,eAAA;EAAiB,gBAAA;EAAkB,cD7CzC;EC6C6D,kBAAA;AAiCtE;;AA9BA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,cDxDK;ECyDL,+CAAA;AAiCF;AA/BE;EACE,gBAAA;EACA,wBAAA;EACA,mBAAA;AAiCJ;;AA7BA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAgCF;;AA5BA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;AA+BF;AA7BE;EACE,OAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDrFK;ECsFL,kDAAA;EACA,qDAAA;AA+BJ;AA7BI;EAAU,cD1FL;EC0FyB,qCAAA;AAiClC;AAhCI;EAAa,wBAAA;EAA0B,qCAAA;AAoC3C;;AAhCA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kDD7FW;EC8FX,eAAA;EACA,cDvGK;AC0IP;AAjCE;EACE,yDDjGQ;ECkGR,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,kCAAA;AAmCJ;;AA/BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,cDrHO;ACuJT;AAhCE;EAAS,cDrHD;ECqHsB,gBAAA;AAoChC;;AA/BA;;;EAGE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,+JACE;EAEF,0CAAA;EACA,kBDnIO;ECoIP,iBAAA;AAgCF;;AA7BA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,qCAAA;EACA,8BAAA;EACA,+BAAA;AAgCF;;AA3BA;;;EAGE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,4BAAA;AA8BF;AA5BE;;;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kCAAA;EACA,mCAAA;EACA,uCAAA;AAgCJ;AA7BE;EAzBF;;;IAyB4C,gBAAA;EAmC1C;AACF;;AAjCA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDjMK;ECkML,kCDvMI;ECwMJ,yBAAA;EACA,sFAAA;AAoCF;AAlCE;EAlBF;IAkB4C,gBAAA;EAsC1C;AACF;AArCE;EAAU,sBAAA;EAAwB,8BAAA;AAyCpC;AAxCE;EAAa,+BAAA;EAAiC,oCAAA;EAAsC,wBAAA;AA6CtF;AA5CE;EAAU,qBDtMF;ECsM8B,oCAAA;EAAsC,cDtMpE;ACuPV;AAhDE;EAAU,qBA1NL;EA0N0B,mCAAA;EAAqC,cA1N/D;AA+QP;AApDE;EAAU,qBDzMH;ECyM8B,oCAAA;EAAsC,cDzMpE;ACkQT;;AAtDA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAyDF;;AAtDA;EACE,kBAAA;EACA,kDDlNW;ECmNX,eAAA;EACA,wBAAA;AAyDF;;AAtDA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cDrOO;AC8RT;AAvDE;EAAS,iBAAA;EAAmB,cDtOrB;ACiST;AAzDE;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yDDrOQ;ECsOR,eAAA;EACA,gBAAA;EACA,cDjPG;ECkPH,qCAAA;EACA,0CAAA;EACA,wBAAA;EACA,kBAAA;AA2DJ;;AAvDA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;AA0DF;AAxDE;ED7NA,kDA3BW;EA4BX,gBAAA;EACA,eC4NqB;ED3NrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ACgUP;AA9DI;EAAQ,cD9PF;AC+TV;AAhEI;EAAU,cDhQL;ACmUT;AAhEE;EAAW,aAAA;EAAe,qBAAA;EAAuB,QAAA;AAqEnD;AApEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cD3QG;EC4QH,kCAAA;AAsEJ;AApEE;EAAU,eAAA;EAAiB,cD7QpB;ACqVT;;AArEA;EACE,gBAAA;EACA,iBAAA;EACA,+CAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;AAwEF;;AArEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAwEF;AAtEE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cD9RvC;EC8R2D,mBAAA;AA4EpE;AA3EE;EACE,OAAA;EACA,WAAA;EACA,+BDtSQ;ECuSR,2CAAA;EACA,kBAAA;EACA,gBAAA;AA6EJ;AA3EE;EACE,YAAA;EACA,2BAAA;AA6EJ;AA3EI;EAJF;IAI4C,gBAAA;EA+E5C;AACF;AA9EI;EAAc,4BAAA;AAiFlB;AAhFI;EAAa,6DAAA;AAmFjB;AAjFE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,kCAAA;AAmFJ;;AA/EA;EACE;IAAyB,sBAAA;EAmFzB;EAlFA;IAA8B,UAAA;IAAY,iBAAA;IAAmB,eAAA;IAAiB,kDAAA;EAwF9E;EAvFA;IAA2B,0BAAA;EA0F3B;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","// Crafting minigame (smith, smelt, cook ...). Docked at the bottom of the\n// screen so the workstation you are using stays in view, in the shared ink\n// look (see theme/_ink.scss). Triggered by craftingSystem.ts starting a\n// session rather than opened by the player.\n@use '../../theme/ink' as ink;\n\n$warn: #d4a455;\n\n.crafting-session-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding-bottom: 5vh;\n  // Only the lower third darkens, the station above stays clear.\n  background: linear-gradient(to top, rgba(2, 3, 8, 0.65), rgba(2, 3, 8, 0) 55%);\n  pointer-events: none;\n  font-family: ink.$font-text;\n}\n\n.crafting-session-shell {\n  @include ink.panel;\n  @include ink.enter;\n  pointer-events: auto;\n  width: min(820px, 94vw);\n  padding: 18px 24px 18px;\n  transition: border-color 0.2s ease;\n\n  &--ok { border-color: ink.$success; }\n  &--fail { border-color: ink.$danger; }\n}\n\n.crafting-session-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid ink.$line;\n\n  &__title { @include ink.title(26px); }\n  &__subtitle { margin-top: 4px; font-size: 14px; color: ink.$text-2; }\n  &__recipe {\n    flex-shrink: 0;\n    padding: 4px 11px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--gold-light);\n    border: 1px solid var(--gold-dark);\n    border-radius: ink.$radius;\n  }\n}\n\n.crafting-session-body {\n  display: flex;\n  gap: 24px;\n  align-items: stretch;\n  min-height: 200px;\n}\n\n.crafting-session-materials {\n  flex: 0 0 190px;\n  padding-right: 20px;\n  border-right: 1px solid ink.$line;\n\n  &__heading { font-size: 13px; font-weight: 600; color: ink.$text-3; margin-bottom: 4px; }\n}\n\n.crafting-session-material {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 0;\n  font-size: 14px;\n  color: ink.$text;\n  border-top: 1px solid ink.$line;\n\n  &__count {\n    font-weight: 600;\n    color: var(--gold-light);\n    white-space: nowrap;\n  }\n}\n\n.crafting-session-stage {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n// Forge phases: where you are in the three steps.\n.crafting-session-steps {\n  display: flex;\n  gap: 6px;\n  margin: 0 0 18px;\n  padding: 0;\n  list-style: none;\n\n  &__item {\n    flex: 1;\n    padding: 6px 0 8px;\n    font-size: 13px;\n    font-weight: 600;\n    color: ink.$text-3;\n    border-bottom: 3px solid ink.$line;\n    transition: color 0.15s ease, border-color 0.15s ease;\n\n    &--done { color: ink.$text-2; border-bottom-color: var(--gold-dark); }\n    &--current { color: var(--gold-light); border-bottom-color: var(--gold-main); }\n  }\n}\n\n.crafting-session-gauge-heading {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  font-family: ink.$font-title;\n  font-size: 19px;\n  color: ink.$text;\n\n  &__value {\n    font-family: ink.$font-text;\n    font-size: 22px;\n    font-weight: 600;\n    color: var(--gold-light);\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n.crafting-session-gauge-labels {\n  display: flex;\n  justify-content: space-between;\n  margin: 8px 2px 6px;\n  font-size: 13px;\n  color: ink.$text-3;\n\n  &__mid { color: ink.$success; font-weight: 600; }\n}\n\n// Shared bar for the gauge, the timing line and the hammer rhythm. The\n// vertical ticks give the eye a scale to judge distance against.\n.crafting-session-gauge,\n.crafting-session-timing,\n.crafting-session-rhythm {\n  position: relative;\n  height: 44px;\n  margin: 0 2px 20px;\n  background:\n    repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.07) 0, rgba(255, 255, 255, 0.07) 1px, transparent 1px, transparent 10%),\n    ink.$ink-field;\n  border: 1px solid ink.$line-strong;\n  border-radius: ink.$radius;\n  overflow: visible;\n}\n\n.crafting-session-gauge__zone,\n.crafting-session-timing__zone {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  background: rgba(143, 191, 138, 0.26);\n  border-left: 2px solid ink.$success;\n  border-right: 2px solid ink.$success;\n}\n\n// Needle: a thin line with a pointer on top, easier to read against the zone\n// edges than a block.\n.crafting-session-gauge__needle,\n.crafting-session-timing__marker,\n.crafting-session-rhythm__marker {\n  position: absolute;\n  top: -8px;\n  bottom: -8px;\n  width: 3px;\n  margin-left: -1.5px;\n  background: var(--gold-light);\n  border-radius: 2px;\n  transition: left 0.1s linear;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: -2px;\n    left: 50%;\n    width: 0;\n    height: 0;\n    margin-left: -6px;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 8px solid var(--gold-light);\n  }\n\n  @media (prefers-reduced-motion: reduce) { transition: none; }\n}\n\n.crafting-session-rhythm__point {\n  position: absolute;\n  top: 50%;\n  width: 34px;\n  height: 34px;\n  margin-left: -17px;\n  margin-top: -17px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  color: ink.$text;\n  background: ink.$ink;\n  border: 2px solid ink.$text-3;\n  transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n\n  @media (prefers-reduced-motion: reduce) { transition: none; }\n\n  &--next { transform: scale(1.15); border-color: var(--gold-main); }\n  &--perfect { border-color: var(--gold-light); background: rgba(255, 255, 255, 0.1); color: var(--gold-light); }\n  &--good { border-color: ink.$success; background: rgba(143, 191, 138, 0.2); color: ink.$success; }\n  &--late { border-color: $warn; background: rgba(212, 164, 85, 0.2); color: $warn; }\n  &--miss { border-color: ink.$danger; background: rgba(217, 120, 109, 0.2); color: ink.$danger; }\n}\n\n.crafting-session-rhythm__grade {\n  position: absolute;\n  top: 100%;\n  margin-top: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.crafting-session-quench-grade {\n  margin-bottom: 8px;\n  font-family: ink.$font-title;\n  font-size: 22px;\n  color: var(--gold-light);\n}\n\n.crafting-session-hint {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  font-size: 14px;\n  color: ink.$text-2;\n\n  &__sep { margin-left: auto; color: ink.$text-3; }\n\n  kbd {\n    display: inline-block;\n    padding: 3px 9px;\n    margin: 0 4px 0 0;\n    font-family: ink.$font-text;\n    font-size: 13px;\n    font-weight: 600;\n    color: ink.$text;\n    background: rgba(255, 255, 255, 0.08);\n    border: 1px solid ink.$line-strong;\n    border-bottom-width: 2px;\n    border-radius: 4px;\n  }\n}\n\n.crafting-session-outcome {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 6px;\n\n  &__title {\n    @include ink.title(28px);\n    &--ok { color: ink.$success; }\n    &--fail { color: ink.$danger; }\n  }\n\n  &__score { display: flex; align-items: baseline; gap: 8px; }\n  &__number {\n    font-size: 56px;\n    font-weight: 600;\n    line-height: 1;\n    color: ink.$text;\n    font-variant-numeric: tabular-nums;\n  }\n  &__unit { font-size: 16px; color: ink.$text-2; }\n}\n\n.crafting-session-footer {\n  margin-top: 16px;\n  padding-top: 14px;\n  border-top: 1px solid ink.$line;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px 28px;\n}\n\n.crafting-session-bar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  &__label { font-size: 13px; font-weight: 600; color: ink.$text-2; white-space: nowrap; }\n  &__track {\n    flex: 1;\n    height: 8px;\n    background: ink.$ink-field;\n    border: 1px solid ink.$line;\n    border-radius: 4px;\n    overflow: hidden;\n  }\n  &__fill {\n    height: 100%;\n    transition: width 0.2s ease;\n\n    @media (prefers-reduced-motion: reduce) { transition: none; }\n\n    &--progress { background: var(--gold-main); }\n    &--quality { background: linear-gradient(90deg, ink.$danger, $warn, ink.$success); }\n  }\n  &__value {\n    min-width: 3em;\n    font-size: 13px;\n    font-weight: 600;\n    text-align: right;\n    color: var(--gold-light);\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n@media (max-width: 640px) {\n  .crafting-session-body { flex-direction: column; }\n  .crafting-session-materials { flex: none; padding: 0 0 12px; border-right: 0; border-bottom: 1px solid ink.$line; }\n  .crafting-session-footer { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
